<template lang="pug">
  .row.home
    Modal(:visible="modalVisible", @hide=`modalVisible=false`)
      .contact-card
        .info
          p.message Shoot me an email!
          input(value="mccallalexander96@gmail.com")
        p.message ...or contact me here:
        .social-links
          a(href="https://www.instagram.com/mccallalexander/", target="_blank")
            i.fa.fa-instagram.fa-2x
          a(href="https://github.com/mccallofthewild", target="_blank")
            i.fa.fa-github.fa-2x
          a(href="https://twitter.com/mccallthetall", target="_blank")
            i.fa.fa-twitter.fa-2x
          a(href="https://www.linkedin.com/in/mccall-alexander-b245347b/", target="_blank")
            i.fa.fa-linkedin.fa-2x

    .col-xs-12
      .row.header-row
        .col-xs-12.header-col
          header
            h1 McCall Alexander
            h2 Web Development & Design
            address Boise, Idaho
            .cta-container
              button(@click="showModal").btn-cta.inline
                .circle-mark
                | Contact me!
              span.or-text.inline ...or check out my
              router-link(tag="button", :to="{name:'portfolio'}").btn-cta.inline
                .circle-mark
                | Portfolio
            nav(v-if="false")
              ul
                li
                  a(href="https://www.instagram.com/mccallalexander/", target="_blank")
                    i.fa.fa-instagram.fa-2x
                li
                  a(href="https://github.com/mccallofthewild", target="_blank")
                    i.fa.fa-github.fa-2x
                li
                  a(href="https://twitter.com/mccallthetall", target="_blank")
                    i.fa.fa-twitter.fa-2x

</template>

<script>
  import { SweetModal, SweetModalTab } from 'sweet-modal-vue/dist/sweet-modal.js'
  import Multiselect from 'vue-multiselect'
  import Project from './Project'
  import Modal from './Modal'
  import projects from './projects'
  import Sine from './Sine'
  import isMobile from 'ismobilejs'

  import Fuse from 'fuse.js'


  export default {
    name: 'hello',
    data () {
      return {
        msg: 'Welcome to Your Vue.js App',
        scrollOrigin:0,
        modalVisible:false,
        projectList:projects,
        query:[]
      }
    },
    computed:{

      isMobile(){
        return isMobile.any
      },
    },
    components:{
      Modal,
    },
    methods:{
      handleScroll(){
        let winHeight = window.innerHeight
        let centerScrollPos = window.scrollY - winHeight/2
        this.scrollOrigin = centerScrollPos
      },
      showModal(){
        this.modalVisible = true;
      }
    },
    mounted(){
      console.log(projects)
      let vm = this;
      let ecount = 0;
      // window.addEventListener('scroll', this.handleScroll);
      // this.handleScroll()
    },
    beforeDestroy () {
      let a = 0
      // window.removeEventListener('scroll');
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../assets/css/media-queries';
  @import '../assets/css/variables';
// *{
//   all:unset !important;
// }

  @keyframes fadeInText{
    from{
      color:white;
    }
    to{
      color:black;
    }
  }




  @keyframes fadeInOut{
    from{
      opacity:1;
      transform:translateY(0px);
    }
    to{
      opacity:0.1;
      transform:translateY(-10px);
    }
  }

  button{
    all:unset;
  }
  .blurred{
    filter:blur(5px);
    transition:filter 1s ease-out;
  }

  .wild{
    $grad-color:rgba(black, 0.2);
    background-image:url(../assets/waterfall.jpg), linear-gradient(to right, $grad-color, $grad-color);
    background-blend-mode:soft-light;
    background-size: cover;
    background-attachment: fixed;
    // background-position:100% 0%;
    @include mobile {
      filter:grayscale(20%);
      background-position: center;
      // background-color:black;
      // background-size:contain;
      background-attachment:unset;
    }
  }
  .sunset{
    // background-image:url(../assets/nightsky_sml.jpg), $sunset;
    background-blend-mode:soft-light;
    background-size: cover;
    background-attachment: fixed;
    @include mobile{

      // background-image: url(../assets/nightsky.jpg);
      background:$mobile_sunset;
      background-size: auto 200vh;
      background-repeat: repeat;
      // position: fixed;
      // height:100vh;
      // width:100vw;
    }
  }
  .flex-center-around{
    display: flex;
    justify-content: space-around;
    align-items:space-around;
  }
  .flex-around-center{
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items:center;
  }
  .contact-card{
    @extend .flex-around-center;
    color:black;
    width:100%;
    height:100%;
    .message{
      margin:1rem;
      font-size: 2rem;
    }
    .info{
      width:100%;
      input{
        font-family: $font-2;
        font-size: 1.25rem;
        // all:unset;
        border:none;
        border-bottom:2px solid black;
        width:60%;
        // box-shadow: 0px 0px 15px rgba($colorE, 0.3);
        padding:5px;
        padding-left:1px;
        &:focus{
          outline:none;
        }
      }
    }
    .social-links{
      @extend .flex-center-around;
      width:100%;
      a{
        all:unset;
        cursor:pointer;
        color:rgba(black, 0.85);
        font-size: 2rem;
      }
    }

  }
  .home{
    position:relative;
    z-index:2;
    // @extend .sunset;
    @extend .wild;
    overflow:hidden;
    color:azure;
    // height:75vh;
    text-align: center;
    // font-family: 'Bungee Hairline', cursive;
// font-family: 'Josefin Sans', sans-serif;
    // font-family: 'Quicksand', sans-serif;
    font-family: 'Cutive Mono', monospace;
    font-family: 'La Belle Aurore', cursive;
    // text-shadow: 0px -1px 10px rgba($colorE, 0.8);
    font-size:1.5rem;
    height:100vh;
    .header-row{
      background: white;
      // animation: fadeInText 1s ease-out;

      color:black;
      mix-blend-mode: screen;
      position: fixed;
      top:0;bottom:0;left:0;right:0;
      .header-col{
        height:100%;
      }
    }
    header{
      // text-transform: uppercase;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      @include iphone4{
        padding-top:2rem;
        display: block;
      }
      @include iphone5{
        display: flex;
      }
      overflow-y:scroll;
      

      height:100%;
      h1{
        line-height: 1em;
        font-size: 9rem;
        margin:0;
      }
      h2{
        // letter-spacing: 0.85rem;
        font-size:5rem;
        margin:0;
      }
      address{
        font-family:'Cutive Mono', monospace;
        font-size:2.5rem;
        text-align: center;
        font-style: normal;
        display: none;
        // font-family: 'Cutive Mono', monospace;
        // letter-spacing: 1.5rem;
      }
      .cta-container{
        perspective: 30rem;
        font-size: 3rem;
        @include mobile {
          font-size:4rem;
        }
      }
      .inline{
        display: inline;
      }
      .or-text{
        font-size: 2.5rem;
        @include mobile {
          display: block;
          font-size:0.8em;
        }
      }
      .btn-cta{
        font-family: $font-1;
        position:relative;
        perspective: 2rem;
        .circle-mark{
          transition:opacity 500ms ease-in-out;
          opacity:0;
          transform:translate3d(10px, -3px, 1px) rotateY(1deg) rotate(-3deg) scale(1.2);
          border:2px solid #ee0e0e;
          border-color:black;
          border-radius: 50%;
          position:absolute;
          top:0;
          bottom:0;
          left:0;
          right:0;
          width:100%;height:100%;
        }
        // font-family: 'Cutive Mono', monospace;
        // background-color:rgba(azure, 0.2);
        font-size:1em;
        border-radius: 1.5px;
        // cursor: url('../assets/fingers-crossed-cursor.ico'), default;
        // padding:0.5rem 1rem;
        margin-top:2rem;
        margin-left:1rem;
        margin-right:1rem;
        transition-property: opacity;
        transition-duration: 500ms;
        transition-timing-function: ease-out;
        border-bottom:2px solid transparent;

        transform:translateZ(0px);
        // box-shadow: 0px 0px 15px rgba($colorE, 0.1);
        &:hover{
          .circle-mark{
            opacity: 1;
          }
        }
        &:focus{
          .circle-mark{
            opacity: 0;
          }
        }
        &:first-child{
          &:hover{
            // border-color:black;
          }
        }
        &:last-child{
          &:hover{
          }
        }
        text-decoration: underline;
        &:hover{
          cursor:pointer;
          // letter-spacing: 0.2rem;
          // transform:scale(1.05);
          // box-shadow: 0px 0px 0px rgba($colorE, 0.0);
          // background-color:rgba(black, 0.1);
          // color:azure;
        }
        &:active{
          background-color:rgba(azure, 0.4);
        }
      }
    }
    nav{
      ul{
        padding:0;
        li{
          display: inline-block;
          list-style: none;
          margin:0 3.5em;
          // text-shadow: 0px -1px 10px rgba($colorE, 0.5);
          z-index:2;
          overflow:hidden;
          a{
            color:azure;
            font-size: 1rem;
            @include iphone6{
              font-size:2rem;
            }
          }
        }
      }
    }
    .sun-container{
      display: none !important;
      position:absolute;
      width: 100%;
      bottom:0;
      left: 0;
      right: 0;
      display: flex;
      justify-content: center;
      align-items:center;
      margin-bottom:40%;
      
    }
    .mountains{
      display: none;
      justify-content: space-around;
      align-items: center;
      .left{
        transform:scale(0.85) translate(100px, -45px);
      }
      .right{
        transform:rotate(-5deg);

      }
    }
  }


  .fade-enter-active, .fade-leave-active {
  transition: opacity 1s
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
    opacity: 0
  }
</style>


// WEBPACK FOOTER //
// Home.vue?04150a90